import { AnyAction } from '@reduxjs/toolkit';

import { State } from '../types/state.interface';
import { Tombstone } from '../interfaces/client/tombstone.interface';

import { TombstoneActions } from '../actions/tombstone/tombstone.actions';

export interface TombstoneState extends State {
  tombstones: Tombstone[];
  tombstone?: Tombstone;
}

export const initialState: TombstoneState = {
  tombstones: []
};

export const tombstoneReducer = (state: TombstoneState = initialState, action: AnyAction) => {
  switch (action.type) {
    case TombstoneActions.SET_TOMBSTONES:
      const { tombstones } = action;
      return {
        ...state,
        tombstones
      };
    case TombstoneActions.SET_TOMBSTONE: {
      const { tombstone } = action;
      // Also patch the matching entry inside `tombstones[]` so any list
      // currently on screen reflects the v3 edit without a full refetch.
      const patched = state.tombstones.map((t) =>
        String(t.id) === String(tombstone?.id) ? { ...t, ...tombstone } : t
      );
      return {
        ...state,
        tombstone,
        tombstones: patched
      };
    }
    default:
      return state;
  }
};
